module.exports = __webpack_public_path__ + "static/media/project-railgun.af97fabd.gif";